import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4367999c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "free"
};
var _hoisted_2 = {
  class: "top"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "Riscern Deep", -1);
});

var _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"info\" data-v-4367999c><div class=\"list\" data-v-4367999c><div data-v-4367999c><div class=\"item\" data-v-4367999c><span class=\"high-text\" data-v-4367999c></span>Deep dataset</div><div class=\"item\" data-v-4367999c><span class=\"high-text\" data-v-4367999c></span>Monitor up to 10 companies</div><div class=\"item\" data-v-4367999c><span class=\"high-text\" data-v-4367999c></span>Export PDF and Excel reports</div><div class=\"item\" data-v-4367999c><span class=\"high-text\" data-v-4367999c></span>No daily Verification Limit</div><div class=\"item\" data-v-4367999c><span class=\"high-text\" data-v-4367999c></span>Verification of Up to 100 Companies/Month</div></div></div></div>", 1);

export default /*#__PURE__*/_defineComponent({
  props: {
    currentData: Object,
    initData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", null, "$" + _toDisplayString(__props.initData.deepPrice) + " USD", 1)]), _hoisted_4]);
    };
  }
});